<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "Show"
})
</script>

<template>
<div>
    <router-view :key="$route.fullPath"></router-view>
</div>
</template>

<style scoped lang="scss">

</style>
